import { render, staticRenderFns } from "./productReviewForSaleLogModal.vue?vue&type=template&id=9c6c6b3e&scoped=true"
import script from "./productReviewForSaleLogModal.vue?vue&type=script&lang=js"
export * from "./productReviewForSaleLogModal.vue?vue&type=script&lang=js"
import style0 from "./productReviewForSaleLogModal.vue?vue&type=style&index=0&id=9c6c6b3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6c6b3e",
  null
  
)

export default component.exports